import { defineStore } from 'pinia'


export const useUserStore = defineStore('user', {
  state: () => ({
    nome: '',
    autenticado: false,
    grupos: [], 
    notifications: false, // 🔥 Adicionado controle de notificações
    feedPermissions: null,
    eventosAdversosPermissions: null,
    appPermissions: {},
    permissoesAtualizadasEm: 0, // Date.now() da última carga de /auth/user/
  }),

  actions: {
    login(
      nome,
      grupos = [],
      notifications = false,
      feedPermissions = null,
      eventosAdversosPermissions = null,
      appPermissions = {}
    ) {
      this.nome = nome
      this.autenticado = true
      this.grupos = grupos
      this.notifications = notifications
      this.feedPermissions = feedPermissions
      this.eventosAdversosPermissions = eventosAdversosPermissions
      this.appPermissions = appPermissions || {}
      this.permissoesAtualizadasEm = Date.now()
    },

    logout() {
      this.nome = ''
      this.autenticado = false
      this.grupos = []
      this.notifications = false
      this.feedPermissions = null
      this.eventosAdversosPermissions = null
      this.appPermissions = {}
      this.permissoesAtualizadasEm = 0
    },

    setNotificationsStatus(status) {
      this.notifications = status
    },

    setPermissions(feedPermissions = null, eventosAdversosPermissions = null, appPermissions = {}) {
      this.feedPermissions = feedPermissions
      this.eventosAdversosPermissions = eventosAdversosPermissions
      this.appPermissions = appPermissions || {}
    }
  },
})
